import { createRouter, createWebHistory } from "vue-router";

const routes = [
	{
		path: "/",
		name: "default",
		component: () => import("../layouts/DefaultLayout.vue"),
		redirect: {
			name: "exhibition"
		},
		children: [
			{
				path: "/exhibition",
				name: "exhibition",
				component: () => import("../views/exhibition.vue")
			},
			{
				path: "/login",
				name: "login",
				component: () => import("../views/login.vue")
			},
			{
				path: "/concat",
				name: "concat",
				component: () => import("../views/concat.vue")
			}
		]
	},
	{
		path: "/client",
		name: "client",
		component: () => import("../layouts/AdminLayout.vue"),
		redirect: {
			name: "project"
		},
		children: [
			{
				path: "/project",
				name: "project",
				component: () => import("../views/projects/index.vue")
			},
			{
				path: "/user",
				name: "user",
				component: () => import("../views/user.vue")
			},
			{
				path:"/strategy",
				name: "strategy",
				component: () => import("../views/strategy.vue")
			},
			{
				path: "/destroy",
				name: "destroy",
				component: () => import("../views/destroy.vue")
			},
			// 负载分析
			{
				path: "/load",
				name: "load",
				component: () => import("../views/calculate/pages/loadAnalysis")
			},
            // 配储方案
            {
                path:"/scheme",
                name: "scheme",
				component: () => import("../views/calculate/pages/scheme")
            },
            // 经济分析
            {
                path:"/economic",
                name:"economic",
                component:()=> import("../views/calculate/pages/economic")
            }
		]
	},
    {
        path:"/report",
        name: "report",
        component: () => import("../views/calculate/pages/report/index.vue")
    },
    {
        path:"/report/v1",
        name: "reportV1",
        component: () => import("../views/calculate/pages/report/reportV1/index.vue")
    }
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes
});

export default router;
